import React from 'react'
import { useParams } from 'react-router-dom'
import PageHeadSection from '../admin/components/PageHeadSection'
import SingleRequest from './SingleRequest'

interface IViewRequestProps {
    hidePageSectionHeader?: boolean
}

export default function ViewRequest(props: IViewRequestProps) {

    const { hidePageSectionHeader } = props

    const params = useParams()
    const requestNumber = params.id ? params.id : ""

    return(
        <div className="admin-view-request-page">

            {!hidePageSectionHeader && <PageHeadSection pageName="item_requests" />}

            <SingleRequest requestNumber={requestNumber} />

        </div>
    )
}